//
// Represents a range of values. Ported from Utilities\ValueRange.cs
//
// Don't edit this file, edit ValueRange.cs and then port changes over to this file.
//
// See ValueRange.cs for comments.
//
export abstract class ValueRange {
    public lowerBound: number;
    public upperBound: number;

    // ===============================================================================

    protected constructor() {
        this.lowerBound = 0;
        this.upperBound = 0;
    }

    // ===============================================================================

    protected roundValue(value: number, numDecimalsToRoundTo: number): number {
        return numDecimalsToRoundTo === -1
            ? value
            : value.roundBy(numDecimalsToRoundTo);
    }

    // ===============================================================================

    protected splitStringToRangedParts(serializedRange: string): string[] {
        const ret: string[] = [""];

        if (serializedRange) {
            for (let i = 0; i < serializedRange.length; i++) {
                const c = serializedRange[i];

                if ((c == '-') || (c == '–') || (c == '—')) {
                    if ((i > 0) && ((serializedRange[i - 1] == 'e') || (serializedRange[i - 1] == 'E'))) {
                        ret[ret.length - 1] += c;
                    }
                    else {
                        ret.push("");
                    }
                }
                else
                {
                    ret[ret.length - 1] += c;
                }
            }
        }

        return ret
            .map(s => s.trim())
            .filter(s => s.length > 0);
    }
}
